import React, { useRef, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";

export default function FileUpload({ category = "patient_photo", patientId = "", onUploaded, label = "Upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const params = new URLSearchParams({ category, patient_id: patientId || "" });
      const { data } = await api.post(`/files/upload?${params.toString()}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Uploaded");
      onUploaded?.(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Upload failed");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div>
      <input ref={ref} type="file" accept="image/*,application/pdf" hidden onChange={onChange} data-testid={`file-upload-${category}`} />
      <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()}>
        <Upload size={14} className="mr-2" />{busy ? "Uploading…" : label}
      </Button>
    </div>
  );
}

export function AuthImage({ fileId, alt = "", className = "" }) {
  const [src, setSrc] = useState("");
  React.useEffect(() => {
    if (!fileId) return;
    let revoked = null;
    api.get(`/files/${fileId}/download`, { responseType: "blob" })
      .then(({ data }) => { const url = URL.createObjectURL(data); revoked = url; setSrc(url); })
      .catch(() => {});
    return () => { if (revoked) URL.revokeObjectURL(revoked); };
  }, [fileId]);
  if (!fileId) return null;
  return src ? <img src={src} alt={alt} className={className} /> : <div className={`${className} bg-secondary animate-pulse`} />;
}
